import api from './axios';
import { AxiosError } from 'axios';

export interface FeedVendor {
  id: string;
  name: string;
  contactPerson?: string;
  phone?: string;
  email?: string;
  address?: string;
  website?: string;
  notes?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateFeedVendorDto {
  name: string;
  contactPerson?: string;
  phone?: string;
  email?: string;
  address?: string;
  website?: string;
  notes?: string;
  isActive?: boolean;
}

export interface UpdateFeedVendorDto extends Partial<CreateFeedVendorDto> {}

export const fetchFeedVendors = async (): Promise<FeedVendor[]> => {
  const response = await api.get('/feeds/vendors');
  
  // Handle wrapped response from TransformInterceptor
  const responseData = response.data;
  
  // Check if the response has the wrapped format
  if (responseData && responseData.data && Array.isArray(responseData.data)) {
    return responseData.data;
  }
  
  // Fallback: check if the response is directly an array
  if (Array.isArray(responseData)) {
    return responseData;
  }
  
  console.error('Invalid fetch feed vendors response format:', responseData);
  throw new Error('Invalid response format from server');
};

export const fetchFeedVendor = async (id: string): Promise<FeedVendor> => {
  const response = await api.get(`/feeds/vendors/${id}`);
  
  // Handle wrapped response from TransformInterceptor
  const responseData = response.data;
  
  // Check if the response has the wrapped format
  if (responseData && responseData.data) {
    return responseData.data;
  }
  
  // Fallback: check if responseData is directly a FeedVendor object
  if (responseData && typeof responseData === 'object' && 'id' in responseData) {
    return responseData;
  }
  
  console.error('Invalid fetch feed vendor response format:', responseData);
  throw new Error('Invalid response format from server');
};

export const createFeedVendor = async (data: CreateFeedVendorDto): Promise<FeedVendor> => {
  const response = await api.post('/feeds/vendors', data);
  
  // Handle wrapped response from TransformInterceptor
  const responseData = response.data;
  
  // Check if the response has the wrapped format
  if (responseData && responseData.data) {
    return responseData.data;
  }
  
  // Fallback: check if responseData is directly a FeedVendor object
  if (responseData && typeof responseData === 'object' && 'id' in responseData) {
    return responseData;
  }
  
  console.error('Invalid create feed vendor response format:', responseData);
  throw new Error('Invalid response format from server');
};

export const updateFeedVendor = async (id: string, data: UpdateFeedVendorDto): Promise<FeedVendor> => {
  const response = await api.put(`/feeds/vendors/${id}`, data);
  
  // Handle wrapped response from TransformInterceptor
  const responseData = response.data;
  
  // Check if the response has the wrapped format
  if (responseData && responseData.data) {
    return responseData.data;
  }
  
  // Fallback: check if responseData is directly a FeedVendor object
  if (responseData && typeof responseData === 'object' && 'id' in responseData) {
    return responseData;
  }
  
  console.error('Invalid update feed vendor response format:', responseData);
  throw new Error('Invalid response format from server');
};

export const deleteFeedVendor = async (id: string): Promise<void> => {
  await api.delete(`/feeds/vendors/${id}`);
}; 